import { replaceAt } from './common'
import Decimal from 'decimal.js'

const locale = 'en-US'

export function formatCurrency(number, digits, currency = {}) {
  const formattedNumber = formatNumber(number, digits)
  // position - always in the beginning
  // symbol - always from endpoint(hardcoded)
  // symbolSpace - add space between symbol and number when true, or auto-detect for SAR
  const shouldAddSpace = currency.symbolSpace ?? currency.symbol === 'SAR'
  const space = shouldAddSpace ? ' ' : ''
  return `${currency.symbol || ''}${space}${formattedNumber}`
}

export function formatNumber(num, digits = {}) {
  // remainder value
  const { min, max } = digits
  return new Intl.NumberFormat(locale, {
    ...(min && { minimumFractionDigits: min }),
    ...((max || max === 0) && { maximumFractionDigits: max })
  }).format(Number(num))
}

export function splitFormattedNumber(num) {
  return num.toString().split('.')
}

export function replaceCurrencySymbol(string, oldCurrencySymbol, newCurrencySymbol) {
  const oldCurrencySymbolIndex = oldCurrencySymbol && string.indexOf(oldCurrencySymbol)

  if (oldCurrencySymbolIndex !== -1) {
    // if currency symbol exist in string, replace it by founded index
    return replaceAt(string, oldCurrencySymbolIndex, newCurrencySymbol)
  } else {
    // if not, just append new symbol to the start
    return newCurrencySymbol + string
  }
}

export function calc(num) {
  // Decimal library is used to avoid cases of calculation like 0.07 * 100 = 7,000000001
  // || 0 to support cases when num is empty '' string - the reason why Number() is not used is because it converts
  // empty string to 0 we will have precision issues for example Number("272252.660005555234234") - > 272252.66000555526
  return new Decimal(num || 0)
}
